import { Link } from 'react-router-dom';
import useAppRoutes from '../AppRoutes';

const Home = () => {

    const routePaths = useAppRoutes();

    return <div>

        <Link to={routePaths.zoekRapporten} className="btn btn-primary btn-block btn-lg" role="button" >
            Zoek visitatierapporten
        </Link>

        <Link to={routePaths.zoekGoedePraktijken} className="btn btn-primary btn-block btn-lg" role="button" >
            Goede praktijken
        </Link>

        <Link to={routePaths.zoekShmPrestaties} className="btn btn-primary btn-block btn-lg" role="button" >
            Welke SHM levert goede of uitstekende prestaties?
        </Link>
            
    </div>
}
export default Home;